import { render, staticRenderFns } from "./CreatePhase.vue?vue&type=template&id=8ca9ea46&"
import script from "./CreatePhase.vue?vue&type=script&lang=js&"
export * from "./CreatePhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports